import React, { useContext } from "react";
import styled from "styled-components";
import { Box } from "reflexbox";

import * as colors from "../../styles/colors";
import { parseMarkdownLinks } from "./parseMarkdownLinks";
import { CrownPriceContext } from "./MdxProvider";

const HeaderBar = styled(Box)`
  background: rgba(42, 199, 220, 0.06);
  border: 1px solid rgba(96, 113, 123, 0.12);
  border-bottom: none;
  padding: 14px 20px;
  border-radius: 12px 12px 0 0;
  font-weight: 500;
  font-size: 15px;
  color: ${colors.light};
`;

const CardBody = styled(Box)`
  background: rgba(12, 15, 20, 0.5);
  border: 1px solid rgba(96, 113, 123, 0.12);
  border-top: none;
  border-radius: 0 0 12px 12px;
  padding: 20px;
`;

export function CardWithHeader({ header, children }) {
  return (
    <Box my={[3]}>
      <HeaderBar>{parseMarkdownLinks(header, { crownPrice: useContext(CrownPriceContext) })}</HeaderBar>
      <CardBody>
        <Box
          fontSize={[14, 15]}
          color={colors.text}
          style={{ lineHeight: "170%" }}
        >
          {children}
        </Box>
      </CardBody>
    </Box>
  );
}
